module.exports = __webpack_public_path__ + "media/images/icon/navigation/transaction-active-64d702a5c41e65d30e36e834810a8ad1.svg";